import React, { useState } from 'react';

export default function ContactForm() {
  const [formData, setFormData] = useState({
    subject: 'Estate Compass',
    name: '',
    email: '',
    message: '',
  });

  const [status, setStatus] = useState(null); // To show the status of submission
  const [errors, setErrors] = useState({}); // To store validation errors

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // Reset errors for the current field
    setErrors({ ...errors, [name]: '' });
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate the form
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required.';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Invalid email address.';
    }
    if (!formData.subject.trim()) newErrors.subject = 'Subject is required.';
    if (!formData.message.trim()) newErrors.message = 'Message is required.';

    // Check if there are any validation errors
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }


    try {
      const response = await fetch('https://email.jason-736.workers.dev/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const result = await response.text();
      if (response.ok) {
        setStatus('Email sent successfully!');
        setFormData({ name: '', email: '', subject: 'Estate Compass', message: '' }); // Reset the form
      } else {
        setStatus(`Failed to send email: ${result}`);
      }
    } catch (error) {
      setStatus(`Error: ${error.message}`);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="cs_contact_form cs_style_1 cs_white_bg cs_radius_30">
          <div className="row">
            <div className="col-lg-6">
              <label className="cs_input_label cs_heading_color">Name</label>
              <input
                type="text"
                className="cs_form_field"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="David John"
              />
              {errors.name && <p style={{ color: 'red' }}>{errors.name}</p>}
              <div className="cs_height_42 cs_height_xl_25" />
            </div>
            <div className="col-lg-6">
              <label className="cs_input_label cs_heading_color">Email</label>
              <input
                type="email"
                name="email"
                className="cs_form_field"
                placeholder="example@gmail.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
              {errors.email && <p style={{ color: 'red' }}>{errors.email}</p>}
              <div className="cs_height_42 cs_height_xl_25" />
            </div>
            <div className="col-lg-12">
              <label className="cs_input_label cs_heading_color">Message</label>
              <textarea
                cols={30}
                rows={10}
                name="message"
                className="cs_form_field"
                placeholder="Write something..."
                value={formData.message}
                onChange={handleChange}
                required
                defaultValue={''}
              />
              {errors.message && <p style={{ color: 'red' }}>{errors.message}</p>}
              <div className="cs_height_42 cs_height_xl_25" />
            </div>
            <div className="col-lg-12">
              <div className="cs_height_18" />
              <button className="cs_btn cs_style_1" type="submit">
                <span>Submit</span>
                <i>
                  <img src="/images/icons/arrow_white.svg" alt="Icon" />
                  <img src="/images/icons/arrow_white.svg" alt="Icon" />
                </i>
              </button>
            </div>
          </div>
        </div>
      </form>
      {status && <p>{status}</p>}
    </div>

  );
}
